import React, { useState, useMemo, Suspense, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const PortfolioPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  // Get all images from the portfolio directory
  const portfolioItems = useMemo(() => {
    const items = [
      // Flyers and Designs
      { src: '/img/portfolio/HomeComing Flyer Countdown Facebook.jpg', category: 'flyers', title: 'Homecoming Flyer' },
      { src: '/img/portfolio/Adjumas Travel and  Tour 2 Flyer.jpg', category: 'flyers', title: 'Travel Flyer' },
      { src: '/img/portfolio/Dr. Patrick W. Adda for GCAC Presiden.jpg', category: 'flyers', title: 'Campaign Flyer' },
      { src: '/img/portfolio/Youth Flyer-ChaleMakeWeVibe copy.jpg', category: 'flyers', title: 'Youth Event Flyer' },
      { src: '/img/portfolio/Preacher kid 2025 flyer.jpg', category: 'flyers', title: 'Event Flyer' },
      { src: '/img/portfolio/RCC FLYER.jpg', category: 'flyers', title: 'Church Flyer' },
      { src: '/img/portfolio/Retirement Service Flyer.jpg', category: 'flyers', title: 'Retirement Service' },
      { src: '/img/portfolio/Chelsea Blaq Masterclass.jpg', category: 'flyers', title: 'Masterclass Flyer' },
      { src: '/img/portfolio/Sly Flyer.jpg', category: 'flyers', title: 'Event Flyer' },
      { src: '/img/portfolio/Apostolic n Impartation Sunday.jpg', category: 'flyers', title: 'Church Event' },
      { src: '/img/portfolio/RVD ENGLISH YOUTH WEEK.jpg', category: 'flyers', title: 'Youth Week' },
      { src: '/img/portfolio/Shito Flyer.jpg', category: 'flyers', title: 'Food Event' },
      { src: '/img/portfolio/Friends and family Sunday.jpg', category: 'flyers', title: 'Family Event' },
      { src: '/img/portfolio/JUICING BY NANA.jpg', category: 'flyers', title: 'Food Event' },
      { src: '/img/portfolio/Afro Paint Party + AFTERPARTY Flyer.jpg', category: 'flyers', title: 'Party Flyer' },
      { src: '/img/portfolio/Birthday Invite_.jpg', category: 'flyers', title: 'Birthday Invitation' },
      { src: '/img/portfolio/Church Picnic.jpg', category: 'flyers', title: 'Church Picnic' },
      { src: '/img/portfolio/Wednesday Connect.jpg', category: 'flyers', title: 'Church Event' },
      { src: '/img/portfolio/Summer School Flyer copy.jpg', category: 'flyers', title: 'Summer School' },
      { src: '/img/portfolio/Christmas Carols Flyer Design.jpg', category: 'flyers', title: 'Christmas Carols' },
      { src: '/img/portfolio/HomeComing Flyer.jpg', category: 'flyers', title: 'Homecoming Event' },
      { src: '/img/portfolio/TRIP DESIGN.jpg', category: 'flyers', title: 'Trip Design' },
      
      // Photography
      { src: '/img/portfolio/Ghanaians ladies.jpg', category: 'photography', title: 'Portrait Photography' },
      { src: '/img/portfolio/graduate with zippy.jpg', category: 'photography', title: 'Graduation Photo' },
      { src: '/img/portfolio/Naming and Catholic wedding Invitation_ Card.jpg', category: 'photography', title: 'Wedding Photo' },
      { src: '/img/portfolio/Mr and Mrs Teye Ogbordjor Naming.jpg', category: 'photography', title: 'Naming Ceremony' },
      { src: '/img/portfolio/IMG_0342.jpg', category: 'photography', title: 'Event Photography' },
      { src: '/img/portfolio/PHOTO_71.jpg', category: 'photography', title: 'Portrait' },
      { src: '/img/portfolio/IMG_4333.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/MATCH.jpg', category: 'photography', title: 'Sports Photo' },
      { src: '/img/portfolio/IMG_0683.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/chow championship.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/IMG_8960.jpg', category: 'photography', title: 'Portrait' },
      { src: '/img/portfolio/SHEVA\'S PALACE.jpg', category: 'photography', title: 'Venue Photo' },
      { src: '/img/portfolio/IMG_7307.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/IMG_0291.jpg', category: 'photography', title: 'Portrait' },
      { src: '/img/portfolio/Celebration of Life copy.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/IMG_0646.jpg', category: 'photography', title: 'Portrait' },
      { src: '/img/portfolio/Mr&Mrs Nyarko family Baby Christening.jpg', category: 'photography', title: 'Christening' },
      { src: '/img/portfolio/IMG_0305.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/PRINCE-MEYSON-2.jpg', category: 'photography', title: 'Portrait' },
      { src: '/img/portfolio/IMG_8834.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/IMG_9914.jpg', category: 'photography', title: 'Portrait' },
      { src: '/img/portfolio/Joseph&Joycelyn Wedding and Baby naming.jpg', category: 'photography', title: 'Wedding Photo' },
      { src: '/img/portfolio/IMG_0616.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/RVD expo booth.jpg', category: 'photography', title: 'Expo Photo' },
      { src: '/img/portfolio/IMG_0015.jpg', category: 'photography', title: 'Portrait' },
      { src: '/img/portfolio/IMG_7140.jpg', category: 'photography', title: 'Event Photo' },
      { src: '/img/portfolio/chow championship Winners 1.jpg', category: 'photography', title: 'Event Winners' },
      
      // Logos
      { src: '/img/portfolio/logo and details 3 (2).jpg', category: 'logos', title: 'Logo Design' },
      { src: '/img/portfolio/ACE TV LOGO-01 copy.jpg', category: 'logos', title: 'TV Logo' },
      { src: '/img/portfolio/MAC DANIELS LOGO 1-01.jpg', category: 'logos', title: 'Brand Logo' },
      { src: '/img/portfolio/Root logo-02.jpg', category: 'logos', title: 'Root Logo' },
      { src: '/img/portfolio/1.png', category: 'logos', title: 'Logo Design' },
      { src: '/img/portfolio/2.png', category: 'logos', title: 'Logo Design' },
      { src: '/img/portfolio/3.png', category: 'logos', title: 'Logo Design' },
      { src: '/img/portfolio/4.png', category: 'logos', title: 'Logo Design' },
      { src: '/img/portfolio/5.png', category: 'logos', title: 'Logo Design' },
      { src: '/img/portfolio/6.png', category: 'logos', title: 'Logo Design' },
    ];
    return items;
  }, []);

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'flyers', label: 'Flyers' },
    { id: 'photography', label: 'Photography' },
    { id: 'logos', label: 'Logos' },
  ];

  const filteredItems = useMemo(() => {
    if (selectedCategory === 'all') return portfolioItems;
    return portfolioItems.filter(item => item.category === selectedCategory);
  }, [portfolioItems, selectedCategory]);

  // Calculate pagination
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = filteredItems.slice(startIndex, endIndex);

  const handleImageLoad = (index) => {
    setLoadedImages(prev => ({
      ...prev,
      [index]: true
    }));
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  // Reset to first page when category changes
  React.useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory]);

  const handleNextImage = useCallback((e) => {
    e.stopPropagation();
    if (!selectedImage) return;
    const currentIndex = filteredItems.findIndex(item => item.src === selectedImage.src);
    const nextIndex = (currentIndex + 1) % filteredItems.length;
    setSelectedImage(filteredItems[nextIndex]);
  }, [filteredItems, selectedImage]);

  const handlePrevImage = useCallback((e) => {
    e.stopPropagation();
    if (!selectedImage) return;
    const currentIndex = filteredItems.findIndex(item => item.src === selectedImage.src);
    const prevIndex = (currentIndex - 1 + filteredItems.length) % filteredItems.length;
    setSelectedImage(filteredItems[prevIndex]);
  }, [filteredItems, selectedImage]);

  // Add keyboard navigation
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'ArrowRight') {
        handleNextImage(e);
      } else if (e.key === 'ArrowLeft') {
        handlePrevImage(e);
      } else if (e.key === 'Escape') {
        setSelectedImage(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, filteredItems, handleNextImage, handlePrevImage]);

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Portfolio</h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Explore our latest creative work
          </p>
        </motion.div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-full transition-all duration-300 text-base font-medium ${
                selectedCategory === category.id
                  ? 'bg-black text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-100 shadow'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Category Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-2xl font-bold mb-8 text-center"
        >
          {selectedCategory === 'all' ? 'All Works' : 
           selectedCategory === 'flyers' ? 'Flyer Designs' :
           selectedCategory === 'photography' ? 'Photography Portfolio' :
           'Logo Designs'}
        </motion.h2>

        {/* Portfolio Grid with Navigation */}
        <div className="relative">
          {/* Navigation Buttons */}
          {totalPages > 1 && (
            <>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 p-3 rounded-full bg-white shadow-lg transition-all ${
                  currentPage === 1
                    ? 'opacity-50 cursor-not-allowed'
                    : 'hover:bg-gray-100 hover:scale-110'
                }`}
                aria-label="Previous page"
              >
                <FaChevronLeft size={24} className="text-gray-700" />
              </button>
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 p-3 rounded-full bg-white shadow-lg transition-all ${
                  currentPage === totalPages
                    ? 'opacity-50 cursor-not-allowed'
                    : 'hover:bg-gray-100 hover:scale-110'
                }`}
                aria-label="Next page"
              >
                <FaChevronRight size={24} className="text-gray-700" />
              </button>
            </>
          )}

          {/* Portfolio Grid */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
          >
            {currentItems.map((item, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 bg-white"
                onClick={() => setSelectedImage(item)}
              >
                <div className="aspect-w-4 aspect-h-3">
                  {!loadedImages[index] && (
                    <div className="absolute inset-0 loading-shimmer" />
                  )}
                  <img
                    src={item.src}
                    alt={item.title}
                    className={`w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500 ${
                      loadedImages[index] ? 'opacity-100' : 'opacity-0'
                    }`}
                    loading="lazy"
                    decoding="async"
                    onLoad={() => handleImageLoad(index)}
                    style={{
                      contentVisibility: 'auto',
                      containIntrinsicSize: '0 300px'
                    }}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white text-lg font-bold mb-1">
                      {item.title}
                    </h3>
                    <p className="text-white/80 text-sm">
                      {item.category.charAt(0).toUpperCase() + item.category.slice(1)}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* Empty State */}
        {filteredItems.length === 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-12"
          >
            <p className="text-gray-500 text-lg">No items found in this category.</p>
          </motion.div>
        )}
      </div>

      {/* Lightbox */}
      <Suspense fallback={<div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center">
        <div className="loading-shimmer w-16 h-16 rounded-full" />
      </div>}>
        <AnimatePresence>
          {selectedImage && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center p-4"
              onClick={() => setSelectedImage(null)}
            >
              {/* Navigation Buttons */}
              <button
                onClick={handlePrevImage}
                className="absolute left-4 top-1/2 -translate-y-1/2 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-all z-10"
                aria-label="Previous image"
              >
                <FaChevronLeft size={24} className="text-white" />
              </button>
              <button
                onClick={handleNextImage}
                className="absolute right-4 top-1/2 -translate-y-1/2 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-all z-10"
                aria-label="Next image"
              >
                <FaChevronRight size={24} className="text-white" />
              </button>

              <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                className="relative max-w-5xl w-full bg-white rounded-xl overflow-hidden"
                onClick={e => e.stopPropagation()}
              >
                <img
                  src={selectedImage.src}
                  alt={selectedImage.title}
                  className="w-full h-auto"
                  loading="eager"
                  decoding="async"
                />
                <div className="p-6 bg-white">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {selectedImage.title}
                      </h3>
                      <p className="text-gray-600">
                        {selectedImage.category.charAt(0).toUpperCase() + selectedImage.category.slice(1)}
                      </p>
                    </div>
                    <button
                      className="text-gray-500 hover:text-gray-700 transition-colors p-2"
                      onClick={() => setSelectedImage(null)}
                    >
                      <FaTimes size={24} />
                    </button>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </Suspense>
    </section>
  );
};

export default PortfolioPage; 